import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "レイヤー 2",
  viewBox: "0 0 20 20"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g data-name=\"レイヤー 1\"><g data-name=\"グループ 13876\"><path d=\"M12.308.801H19.2v6.892\" data-name=\"パス 10974\" style=\"fill:none;stroke:#0563c1;stroke-width:1.6px;stroke-linecap:round;stroke-linejoin:round;\"></path><path d=\"m18.338 1.663-8.615 8.615\" data-name=\"パス 10975\" style=\"fill:none;stroke:#0563c1;stroke-width:1.6px;stroke-linecap:round;\"></path><path d=\"M15.8 11.391v7.048c0 .41-.331.743-.74.743H1.54a.74.74 0 0 1-.74-.743V4.925c0-.41.331-.743.74-.743h7.006\" style=\"fill:none;stroke:#0563c1;stroke-width:1.6px;\"></path></g></g>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }